import EfdAgentChat, { PPI_AGENT } from './EfdAgentChat';

/**
 * Assistant Bro PPI — the SQL data agent on the survista data of the PPI
 * platform. Same chat surface as Assistant Bro MH (welcome snapshot, VIPs,
 * speech-to-speech, Word export); only endpoints, keys and texts differ,
 * and those come from PPI_AGENT. Backend: src/ppi_agent/ (profile "ppi").
 */
function PpiAgentChat(props) {
  return <EfdAgentChat {...props} agent={PPI_AGENT} />;
}

export default PpiAgentChat;
